/* eslint-disable */

var affiliates = {
	init: function() {
		affiliates.getAffiliateVar();
		affiliates.checkCookie();

		var attempts = 0;
		var waitforForm = setInterval( function() {
			var hsFormsIframeEls = document.getElementsByClassName( 'hs-form-iframe' );
			var referralInputEl = document.querySelectorAll( '.hs-input[name="var_referral_token"]' );
			if ( referralInputEl.length ) {
				clearInterval( waitforForm );
				affiliates.checkCookie();
			}
			if ( hsFormsIframeEls.length ) {
				affiliates.checkCookie();
			}
			if ( attempts >=  50 ) {
				clearInterval( waitforForm );
				affiliates.checkCookie(); // Try again just in case
			}
			attempts++;
		}, 100 );

	},
	getAffiliateVar: function() {

		// Read a page's GET URL variables and return them as an associative array.
		function getUrlVars()
		{
				var vars = [], hash;
				var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
				for(var i = 0; i < hashes.length; i++)
				{
						hash = hashes[i].split('=');
						vars.push(hash[0]);
						vars[hash[0]] = hash[1];
				}
				return vars;
		}

		// look for ?var= and get value
		var affiliateVar = getUrlVars()['var'];

		if ( affiliateVar ) {
			// if var is letters, call setCookie
			var affiliateRegex = /^[a-zA-Z0-9]+$/;

			if ( affiliateRegex.test( affiliateVar ) ) {
				affiliates.setCookie( 'dmaffiliate', affiliateVar, 365 );
			}
		}
	},
	setCookie: function( cname, cvalue, exdays ) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = 'expires='+d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;domain=forust.com';
	},
	getCookie: function( cname ) {
		var name = cname + '=';
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	},
	checkCookie: function(){
		// check for affiliate cookie
		var affiliate = affiliates.getCookie( 'dmaffiliate' );

		if ( affiliate != '' ) {

			// check for *iframed* Hubspot forms
			var hsFormsIframeEls = document.getElementsByClassName( 'hs-form-iframe' );
			if ( hsFormsIframeEls.length ){

				// run for each form in case there are multiple
				Array.prototype.forEach.call( hsFormsIframeEls, function(el) {

					// check for hidden input field for referral token
					var referralInputEl = el.contentWindow.document.body.querySelectorAll( '.hs-input[name="var_referral_token"]' );

					if ( referralInputEl.length ){

						//set value from cookie
						referralInputEl[0].setAttribute( 'value', affiliate );

						// trigger event to register change
						var event = document.createEvent( 'HTMLEvents' );
						event.initEvent( 'change', true, false );
						referralInputEl[0].dispatchEvent( event );
					}
				});
			}

			// check for *non-iframed* Hubspot forms
			var hsFormEls = document.getElementsByClassName( 'hs-form' );
			if ( hsFormEls.length ){

				// run for each form in case there are multiple
				Array.prototype.forEach.call( hsFormEls, function(el) {

					// check for hidden input field for referral token
					var referralInputEl = el.querySelectorAll( '.hs-input[name="var_referral_token"]' );

					if ( referralInputEl.length ){

						// set value from cookie
						referralInputEl[0].setAttribute( 'value', affiliate );

						// trigger event to register change
						var event = document.createEvent( 'HTMLEvents' );
						event.initEvent( 'change', true, false );
						referralInputEl[0].dispatchEvent( event );
					}
				});
			}
		}
	}
};

// wait for form to render before checking for hidden referral input
window.addEventListener( 'load', function(){
	affiliates.init();
} );
